import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Slider from "@mui/material/Slider";
import Solve from "./Solve";

const QRef = () => {
  const [isSolving, setIsSolving] = useState(false);
  const [subject, setSubject] = useState();
  const [checked, setChecked] = useState([
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
    [true, true, true, true, true, true, true],
  ]);
  const [show, setShow] = useState({
    21: false,
    20: false,
    19: false,
    18: false,
    17: false,
    16: false,
    15: false,
    14: false,
  });
  const [testList, setTestList] = useState([]);
  const [qNumRange, setQNumRange] = useState([1, 20]);

  const subArr = [
    ["phy1", "물리학1"],
    ["phy2", "물리학2"],
    ["che1", "화학1"],
    ["che2", "화학2"],
    ["bio1", "생명과학1"],
    ["bio2", "생명과학2"],
    ["ear1", "지구과학1"],
    ["ear2", "지구과학2"],
  ];
  const monthArr = [
    ["03", "3월 모의고사"],
    ["04", "4월 모의고사"],
    ["06", "6월 모의고사"],
    ["07", "7월 모의고사"],
    ["09", "9월 모의고사"],
    ["10", "10월 모의고사"],
    ["11", "수학능력시험"],
  ];
  const yearArr = [
    ["21", "2021년 시행"],
    ["20", "2020년 시행"],
    ["19", "2019년 시행"],
    ["18", "2018년 시행"],
    ["17", "2017년 시행"],
    ["16", "2016년 시행"],
    ["15", "2015년 시행"],
    ["14", "2014년 시행"],
  ];
  const subjectChange = (event) => {
    setSubject(event.target.value);
  };

  return (
    <>
      {!isSolving ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "scroll",
            padding: "5vh",
            height: "79vh",
          }}
        >
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">과목</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={subject}
                label="subject"
                onChange={subjectChange}
              >
                {subArr.map((sub) => (
                  <MenuItem value={sub[0]}>{sub[1]}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {yearArr.map((year, yearIndex) => {
            return (
              <>
                <FormControlLabel
                  label={year[1]}
                  control={
                    <>
                      <button
                        onClick={() => {
                          const newShow = { ...show };
                          newShow[year[0]] = !newShow[year[0]];
                          setShow(newShow);
                        }}
                      >
                        {show[year[0]] ? "➖" : "➕"}
                      </button>
                      <Checkbox
                        checked={
                          checked[yearIndex][0] &&
                          checked[yearIndex][1] &&
                          checked[yearIndex][2] &&
                          checked[yearIndex][3] &&
                          checked[yearIndex][4] &&
                          checked[yearIndex][5] &&
                          checked[yearIndex][6]
                        }
                        onChange={() => {
                          const newChecked = [...checked];
                          const isChecked =
                            checked[yearIndex][0] &&
                            checked[yearIndex][1] &&
                            checked[yearIndex][2] &&
                            checked[yearIndex][3] &&
                            checked[yearIndex][4] &&
                            checked[yearIndex][5] &&
                            checked[yearIndex][6];

                          for (let i = 0; i < 7; i++) {
                            newChecked[yearIndex][i] = !isChecked;
                          }
                          setChecked(newChecked);
                        }}
                      />
                    </>
                  }
                />
                {subject &&
                  show[year[0]] &&
                  subject.indexOf("2") === -1 &&
                  monthArr.map((month, monthIndex) => (
                    <div>
                      <FormControlLabel
                        label={month[1]}
                        control={
                          <>
                            <Checkbox
                              checked={checked[yearIndex][monthIndex]}
                              onChange={() => {
                                const newChecked = [...checked];
                                newChecked[yearIndex][monthIndex] =
                                  !newChecked[yearIndex][monthIndex];
                                setChecked(newChecked);
                              }}
                            />
                          </>
                        }
                      />
                    </div>
                  ))}
                {subject &&
                  show[year[0]] &&
                  subject.indexOf("2") !== -1 &&
                  monthArr.slice(1).map((month, monthIndex) => (
                    <div>
                      <FormControlLabel
                        label={month[1]}
                        control={
                          <>
                            <Checkbox
                              checked={checked[yearIndex][monthIndex]}
                              onChange={() => {
                                const newChecked = [...checked];
                                newChecked[yearIndex][monthIndex] =
                                  !newChecked[yearIndex][monthIndex];
                                setChecked(newChecked);
                              }}
                            />
                          </>
                        }
                      />
                    </div>
                  ))}
              </>
            );
          })}
          <Slider
            getAriaLabel={() => "Temperature range"}
            value={qNumRange}
            onChange={(event, newValue) => {
              setQNumRange(newValue);
            }}
            valueLabelDisplay="auto"
            getAriaValueText={() => `${qNumRange}번`}
            min={1}
            max={20}
          />
          <Button
            variant="contained"
            disableElevation
            onClick={() => {
              if (!subject) return;
              const newTestList = [];
              for (let i = 0; i < yearArr.length; i++) {
                for (let j = 0; j < monthArr.length; j++) {
                  if (subject.indexOf("2") !== -1 && monthArr[j][0] === "03")
                    continue;
                  if (checked[i][j] === true) {
                    if (
                      monthArr[j][0] === "06" ||
                      monthArr[j][0] === "09" ||
                      monthArr[j][0] === "11"
                    ) {
                      newTestList.push(
                        String(parseInt(yearArr[i][0]) + 1) + monthArr[j][0]
                      );
                    } else newTestList.push(yearArr[i][0] + monthArr[j][0]);
                  }
                }
              }
              if (newTestList.length > 0) {
                setTestList(newTestList);
                setIsSolving(true);
              }
            }}
          >
            문제풀기
          </Button>
        </div>
      ) : (
        <Solve subject={subject} testList={testList} qNumRange={qNumRange} />
      )}
    </>
  );
};
export default QRef;
